'use client';
import React, { useState } from 'react';

import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

const facilities = [
{
  id: 'clubhouse',
  title: 'Our Clubhouse',
  description: 'Relax in our clubhouse with its scenic veranda overlooking the course. Enjoy refreshments, a full bar, and the warm atmosphere of the 19th hole.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16de181d3-1772230712540.png",
  alt: 'Maritzburg Golf Club clubhouse with veranda overlooking the golf course'
},
{
  id: 'padel',
  title: 'Padel Courts',
  description: 'State-of-the-art Padel courts available for members and visitors. A great way to complement your golf with another exciting sport.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fd842f47-1784689489457.png",
  alt: 'Padel courts at Maritzburg Golf Club'
},
{
  id: 'squash',
  title: 'Squash Courts',
  description: 'Our well-maintained squash courts are perfect for a competitive game or a fitness workout before or after your round of golf.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13bd7a01e-1784689488781.png",
  alt: 'Squash courts at Maritzburg Golf Club'
},
{
  id: 'proshop',
  title: 'The Pro Shop',
  description: 'Stop by The Pro Shop for expert advice, quality gear, and professional lessons from our experienced team of golf professionals.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14c93758d-1784689490330.png",
  alt: 'The Pro Shop at Maritzburg Golf Club with golf equipment and apparel'
}];


export default function FacilitiesSection() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-20 bg-background">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="text-center mb-12">
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Our Facilities</span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2">More Than Just Golf</h2>
          <p className="text-muted-foreground mt-3 max-w-2xl mx-auto text-base">
            At Maritzburg Golf Club, we offer more than just a great round of golf. Our facilities are designed to create a welcoming environment for members, visitors, and families alike.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
            <AppImage
              src={facilities?.[active]?.image}
              alt={facilities?.[active]?.alt}
              fill
              className="object-cover transition-all duration-500" />
            
            <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4">
              <span className="text-white font-bold text-xl">{facilities?.[active]?.title}</span>
            </div>
          </div>

          {/* Facility list */}
          <div className="space-y-4">
            {facilities?.map((facility, idx) =>
            <button
              key={facility?.id}
              onClick={() => setActive(idx)}
              className={`w-full text-left p-5 rounded-xl border-2 transition-all duration-200 ${
              active === idx ?
              'border-primary bg-primary/5 shadow-md' :
              'border-border bg-card hover:border-primary/40'}`
              }>
              
                <div className="flex items-start gap-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${active === idx ? 'gradient-primary' : 'bg-muted'}`}>
                    <Icon
                    name={idx === 0 ? 'BuildingStorefrontIcon' : idx === 1 ? 'TrophyIcon' : idx === 2 ? 'BoltIcon' : 'ShoppingBagIcon'}
                    size={20}
                    variant="outline"
                    className={active === idx ? 'text-white' : 'text-muted-foreground'} />
                  
                  </div>
                  <div>
                    <div className={`font-semibold text-base mb-1 ${active === idx ? 'text-primary' : 'text-foreground'}`}>
                      {facility?.title}
                    </div>
                    <p className="text-muted-foreground text-sm leading-relaxed">{facility?.description}</p>
                  </div>
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>);

}